import classnames from "classnames";
import React from "react";
import { IRaceData } from "@Types/common";
import Icon from "../../icon";
import styles from "./index.module.less";

export interface IRollingTextProps {
  data: IRaceData[];
  showIcon?: boolean;
  needDateHighlight?: boolean;
  needExtraHightlight?: boolean;
  customerText?: (item: IRaceData) => JSX.Element;
  containerStyle?: React.CSSProperties;
}

const RollingText: React.FC<IRollingTextProps> = (props: IRollingTextProps) => {
  const {
    data,
    needDateHighlight = true,
    needExtraHightlight = true,
    customerText,
    containerStyle,
    showIcon = true,
  } = props;
  let style: React.CSSProperties = {
    width: `${(data.length || 1) * 263}px`,
    animationDuration: `${data.length}s`,
  };

  if (data?.length === 0) {
    return <></>;
  }

  return (
    <section className={styles["rolling-container"]} style={containerStyle}>
      {showIcon && (
        <div className={styles["rolling-icon"]}>
          <Icon type='icon-tongzhibeifen' />
        </div>
      )}
      <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
        <div className={styles["rolling-text"]} style={style}>
          {data.map((item, index) => {
            const { name, extra, time, type } = item;
            const dateCls = classnames({
              [styles["rolling-text__highlight"]]: needDateHighlight,
            });
            const ExtraCls = classnames({
              [styles["rolling-text__highlight"]]: needExtraHightlight,
            });
            return (
              <span className={styles["rolling-text__item"]} key={index.toString(36)}>
                {customerText ? (
                  customerText(item)
                ) : (
                  <span className={styles["rolling-text__line"]}>
                    {time && <span className={dateCls}>{time}</span>}用戶
                    {name && <span>{name}</span>}
                    {type && <span>{type}</span>}
                    {extra && <span className={ExtraCls}>{extra}</span>}
                    菜單
                  </span>
                )}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RollingText;
